import { DataService } from 'src/app/common/data.service';
import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppTokenHandler } from '../../common/app-token-handler';
import { environment } from '../../../environments/environment';
import { TopNavbarComponent } from "../../out-of-application/top-navbar/top-navbar.component";

enum Roles {
    Admin = 1,
    Finance = 2,
    // SLHR = 3,
    // CFTL = 4,
    // CHR = 5,
    // LocationOwner = 6,
    // User = 7
}

@Component({
  standalone: false,
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {
    menuitems: MenuItem[];
    useritems: MenuItem[];
    subitems: Array<{ label: string, icon: string, routerLink: string }> = [];
    pageurl:string;
    ApplicationCode:string="VTS";
    constructor(private router: Router, private appToken: AppTokenHandler,private dataService:DataService, private cdr: ChangeDetectorRef) {
    }
    ngOnInit() {
        this.BindMenuItems();
    }
    CreateNewRequest() {
        this.appToken.setRequestType('');
        this.router.navigate(['/home/new']);
    }
    OpenTab() {      
        let _privacyNotice= "assets/ultimate_guide.pdf";
        window.open(_privacyNotice,'_blank');
    }
    BindMenuItems() {
        this.menuitems = [
            {
                label: 'Home', routerLink: '/home/dashboard'
            },
            {
                label: 'Vendor Request', routerLink: '/vendorrequest'
            },
            {
                label: 'Vendor Approval', routerLink: '/vendorapproval'
            },
            {
                label: 'ECC Vendor Search', routerLink: '/eccvendorsearch'
            },
            // {
            //     label: 'Modify Vendor', routerLink: '/vendormodify'
            // },
            // {
            //     label: 'Tracking Progress',
            //     items: [
            //         //{ label: 'Create New Request', routerLink: '/home/new' }
            //         { label: 'Create Request', command: () => this.CreateNewRequest() }
            //     ],
            //     visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Counsellor]))
            // },
            // {
            //     label: 'Views',
            //     items: [                    
            //         { label: 'View Tracking Requests', routerLink: '/home/trackinglist' }
            //     ],
            //     visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Counsellor]) || this.appToken.IsInRole(Roles[Roles.SLHR]) || this.appToken.IsInRole(Roles[Roles.CHR]) || this.appToken.IsInRole(Roles[Roles.CFTL]))
            // },
            // {
            //     label: 'Reports',
            //     items: [                    
            //         { label: 'Tracking Requests Report', routerLink: '/home/reports' },
            //         { label: 'Tracking Status Summary Report', routerLink: '/home/SummaryReport' }
            //     ],
            //     visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.SLHR]) || this.appToken.IsInRole(Roles[Roles.CHR]) || this.appToken.IsInRole(Roles[Roles.CFTL])),
               
            // },
            // {
            //     label: 'Useful Resources',
            //     items: [                    
            //         { label: 'FAQ', command: () => this.OpenTab() },                   
            //     ],
               
            // },
            // {
            //     label: 'Masters',
            //     items: [
            //         { label: 'Location Owner Mapping', routerLink: '/home/location' },
            //         { label: 'Location & Floor Mapping', routerLink: '/home/floor' }
            //     ],
            //     visible: (this.appToken.IsInRole(Roles[Roles.Admin]))
            // }
        ];

        if (!environment.production) {
             this.subitems.push({ label: 'Run as different user', icon: 'fa fa-unlock', routerLink: '/dummylogin' });
        }
        this.subitems.push({ label: 'Logout', icon: 'fa fa-sign-out', routerLink: '/logout' });
        this.useritems = [
            {
                label: this.appToken.getLoginUserInfo().EmpName, icon: 'fa fa-user',
                items: this.subitems
            },
        ];

    };
}
